module.exports = "https://img.xiyuyouxi.com/saas/img/rmb_icon3.7b041e32.png";